import { message } from 'antd';
import i18n from '../../i18n';
import { buildReportSummaryParams, fetchReportSummary } from '../../services/reportSummary';
import { setTableReportData, setIsLoading } from '../actions/reportSummary';
import { groupData } from '../../pages/GovernmentServiceEducation/utils/dataPreparationSummaryEvents';

export const loadReportSummary = (selectors) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await fetchReportSummary(buildReportSummaryParams(selectors));
    const result = response.data;
    if (!result[0] || !result[0].data) return;

    const { reportKindId } = selectors;
    const data = result[0].data;
    const preparedData = (reportKindId === 2) ? groupData(data) : data;
    dispatch(setTableReportData(preparedData));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  } finally {
    dispatch(setIsLoading(false));
  }
};